var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-tag",style:(_vm.defaultStyle)},[_vm._t("default",function(){return [_vm._v("即报即采")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }